module.exports = __webpack_public_path__ + "static/media/Team.b00cb527.png";